import { PersistedStateV3 } from "./PersistSchema";
import { LocalStorageDriver } from "./LocalStorageDriver";

const STORAGE_KEY = "paws_quiz_v2";
const driver = new LocalStorageDriver<PersistedStateV3>(STORAGE_KEY);

let saveTimeout: any = null;

export function saveQuiz(state: PersistedStateV3) {
  clearTimeout(saveTimeout);
  saveTimeout = setTimeout(() => {
    driver.save(state);
  }, 80);
}

// Cancels any pending debounced save as well, so a save scheduled just before
// checkout cannot resurrect the cleared state.
export function clearSavedQuiz() {
  clearTimeout(saveTimeout);
  saveTimeout = null;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // storage unavailable — nothing to clear
  }
}
